export const COUNTRY_CODES = ['AU', 'BE', 'CA', 'DK', 'DE', 'IE', 'ES', 'SE', 'NL', 'US', 'GB', 'AR'];

export const US_STATES = [
  'US-AL',
  'US-AK',
  'US-AZ',
  'US-AR',
  'US-CA',
  'US-CO',
  'US-CT',
  'US-DE',
  'US-FL',
  'US-GA',
  'US-HI',
  'US-ID',
  'US-IL',
  'US-IN',
  'US-IA',
  'US-KS',
  'US-KY',
  'US-LA',
  'US-ME',
  'US-MD',
  'US-MA',
  'US-MI',
  'US-MN',
  'US-MS',
  'US-MO',
  'US-MT',
  'US-NE',
  'US-NV',
  'US-NH',
  'US-NJ',
  'US-NM',
  'US-NY',
  'US-NC',
  'US-ND',
  'US-OH',
  'US-OK',
  'US-OR',
  'US-PA',
  'US-RI',
  'US-SC',
  'US-SD',
  'US-TN',
  'US-TX',
  'US-UT',
  'US-VT',
  'US-VA',
  'US-WA',
  'US-WV',
  'US-WI',
  'US-WY',
  'US-DC',
  'US-AS',
  'US-GU',
  'US-MP',
  'US-PR',
  'US-VI',
];

export const CA_STATES = [
  'CA-AB',
  'CA-BC',
  'CA-MB',
  'CA-NB',
  'CA-NL',
  'CA-NS',
  'CA-ON',
  'CA-PE',
  'CA-QC',
  'CA-SK',
  'CA-NT',
  'CA-NU',
  'CA-YT',
];

export const CURRENCIES = ['USD', 'GBP', 'EUR', 'SEK', 'DKK', 'AUD', 'CAD'];
